/**
 * The pending plan proposals of the editor's frame (spec 2026-10-21-11 §8).
 *
 * A proposal row dirties the `assets` scope, and `live-invalidation.ts` lists
 * the proposals path under it, so a hint refetches the list. While the socket
 * is not live, the list polls.
 */
import { $api } from '../../api'
import type { components } from '../../api/schema'
import { useLiveSubscription, useScopeLive } from '../../contexts/LiveEventsContext'

export type PlanProposal = components['schemas']['PlanProposal']

export const PLAN_PROPOSALS_PATH = '/api/v1/organizations/{orgCode}/assets/{assetUid}/plan/proposals' as const

const POLL_MS = 30_000

export function usePlanProposals(org: string, frameAssetUid: string) {
    useLiveSubscription({ entity: 'assets' })
    const live = useScopeLive({ entity: 'assets' })
    const query = $api.useQuery(
        'get',
        PLAN_PROPOSALS_PATH,
        { params: { path: { orgCode: org, assetUid: frameAssetUid }, query: { status: 'pending' } } },
        { refetchInterval: live ? false : POLL_MS },
    )
    return { proposals: query.data?.data ?? [], refetch: query.refetch }
}
